<template>
  <NotFoundContent />
</template>

<script setup lang="ts">
import NotFoundContent from '@/components/NotFoundContent.vue'
</script>